import { render } from "./OverviewHero.vue?vue&type=template&id=8fca495a&scoped=true"
import script from "./OverviewHero.vue?vue&type=script&lang=js"
export * from "./OverviewHero.vue?vue&type=script&lang=js"

import "./OverviewHero.vue?vue&type=style&index=0&id=8fca495a&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fca495a"]])

export default __exports__